// Constants for SurveyMonkey IDs
export const PAGE_ID_FEEDBACK = '69831590';

export const QUESTION_ID_SATISFACTION = '261978068';
export const CHOICE_ID_SATISFIED = '1845078388';

export const QUESTION_ID_OTHER_FEEDBACK = '261978292';
export const OTHER_ID_FEEDBACK = '1845079765';

export const QUESTION_ID_MESSAGE = '261978702';
export const QUESTION_ID_SKU = '261978733';
export const QUESTION_ID_PRODUCT_TITLE = '261978787';
export const QUESTION_ID_DEPARTMENT = '261978812';
export const NOTAPPLY = 'N/A';

export const ID_COMPRAS_NotAbleAddToCart = '1845079762';
export const ID_COMPRAS_ProductArrivedDamaged = '1845079763';
export const ID_COMPRAS_ProductAvailability = '1845079764';
export const ID_COMPRAS_Other = '1164092685';
export const ID_INFO_ProductTitle = '1845086828';
export const ID_INFO_ProductDescription = '1845086829';
export const ID_INFO_ProductImage = '1845086830';
export const ID_INFO_TechnicalSpecifications = '1845086831';
export const ID_INFO_MaterialCalculator = '1845086832';
export const ID_INFO_Other = '1164092697';
export const COMPLETED = 'completed';
